/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_map.js                                                                               */
/**********************************************************************************************************************/
/* Controller.Map */

HafasWebapp.prototype.Controller.Map = {
  instance:null, // will be initialized onload
  selectionMap:null,
  connectionMaps:[],
  markerSEARCH: null,
  markerSTART: null,
  markerDEST: null,
  reverseLookUpTimeout: null,
  searchMode: 'line',
  locGraphMapContent: [],
  stbLocContainer: [],
  LineSearchCommonArr: null,
  LineSearchLineLArr: null,
  processedLineD: null,
  statOnTime: null,
  currentDragRequestCounter: 0,
  productName: null,
  dragHint: null,
  updateOffset: function() {
    var mapInstance;
    if (this.main) {
      mapInstance = this.main.Controller.Map.instance;
    }
    if (!this.main) {
      mapInstance = this.Controller.Map.instance;
    }

    var yPadding = Hafas.Config.Maps.offsetTop;

    // Map functions for md, lg, xlg
    if (this.mq == 'md' || this.mq == 'lg' || this.mq == 'xlg') {
      var xPadding;

      switch (this.mq) {
        case 'xlg':
          xPadding = 650;
          break;
        case 'lg':
          xPadding = 650;
          break;
        case 'md':
          xPadding = 332;
          break;
      }
      mapInstance.setOffset({x: xPadding, y: yPadding});
    }
    else {
      // padding von 0 für smartView (50 = Höhe des Headers muss berücksichtigt werden)
      mapInstance.setOffset({x: 0, y: 50});
    }
  },
  index: function() {
    var me = this;
    var model = {};

    if(Hafas.Config.showQueryHistories && Hafas.Config.showFavorites) {
      model.customerFavorites = {
        name: Hafas.Modules.i18n.get('common.label.t_N_Favorites'),
        closeButton: Hafas.Modules.i18n.get('common.label.t_N_Close'),
        icon_class: '',
        visibility: "none",
        tpl: 'Common_FavTab',
        tabid: 'HFS_CustomerFavorites',
        trigger: 'data-trigger="favoriteChangeInfo"',
        tabcontent: [
          {
            tabid: 'FavMap',
            visibility: "none",
            name: '<span class="label">Map</span>',
            icon_class: '',
            tpl: 'Common_Map'
          }
        ]
      };
    }

    Hafas.Core.newType("hafasLoader", {
      file: 'map.index.html',
      tplId: 'Map_TplIndex',
      callback: function(templateId) {
        var master = templateId;
        Hafas.Modules.Render.render({target: me.formContainer, template: master, model: model}, function() {
          me.Controller.Map.inpMapLocation = Hafas.Core.newType('hafasSuggest', {loc: "MapLocation", config: Hafas.Config.Suggest, type: "S"});

          if (me.layoutClass == 'small') {

            window.setTimeout(function() {

              var $map = Hafas('#HFS_PageMap', false);

              var re = new RegExp('js_mapTabInactive', 'g');

              if ($map.className.match(re)) {
                Hafas('[data-target="FavMap"]', false).click();
              }
            }, 500);
          }


          Hafas.ps.pub('/app/events/resize');
        });
      }
    });
  },

  postForm: function(data) {
    // function is responsible for "map search" feature
    // toggleable by setting config key "useMapSearch" to true
    // currently not implemented -> there is no template for this
    // in common.sidedrawer.html there is more information

    if (typeof data.ev != 'undefined')
      data.ev.preventDefault();

    // close all additional resultcontainer
    Hafas.ps.pub('/GUI/results/additional/hideAll');

    this.Controller.Map.validate(['MapLocation'], Hafas.bind(function() {
      var form = Hafas.Core.newType("hafasValidation", {
        form: data.form
      });
      // If input are valid -> proceed with connection search
      if (form.valid) {
        // show loadingImage and set Button to disabled
        if (data.form.elements.submitMapLocationForm) {
          Hafas.bind(this.Controller.App.triggerLoadingImage, this)(data.form.elements.submitTPForm);
        }
      }
    }, this));
    if(Hafas.Config.Switches.useSidedrawer) {
      Hafas.ps.pub('/map/sidedrawer/toggle', [{}]);
    }
  },
  validate: function(data, callback) {

    this.main.Controller.Map.inpMapLocation.validateLocation(true, Hafas.bind(function() {}));
  },
  toggleSearchMode: function(mode) {
    Hafas('[data-search="line"]').removeClassName('hidden');
  },
  toolbox: {
    stationsNearList: [],
    stationsnear: {
      getStations: function(data) {
        // +++ /map/toolbox/stationsnear/getStations +++
        var _me = this;

        var mapController = _me.Controller.Map;
        var mapInstance = null;
        if (Hafas.Config.layoutMode == '_classic') {
          mapInstance = mapController.selectionMap;
        } else {
          mapInstance = mapController.instance;
        }

        // clear stationsnear, if existing
        for (var l = 0; l < mapController.toolbox.stationsNearList.length; l++) {
          var mrk = mapController.toolbox.stationsNearList[l];
        }
        mapController.toolbox.stationsNearList = [];

        var requestObj = {
          ring: {
            cCrd: {
              y: parseInt(data.location.crd.y),
              x: parseInt(data.location.crd.x)
            },
            maxDist: Hafas.Config.Maps.toolbox.stationsNearRadius
          },
          getPOIs: false,
          getStops: true,
          maxLoc: 5
        };

        Hafas.Core.newType('hafasRequest', {
          request: "LocGeoPos",
          requestType: "hci",
          requestobj: requestObj,
          loadingModule: "LocGeoPos",
          callback: function(res) {
            mapController.toolbox.stationsnear.showResult(res, _me);
          }
        });
      },
      showResult: function(result, _me) {
        var mapController = _me.Controller.Map;
        var mapInstance = null;
        if (Hafas.Config.layoutMode == '_classic') {
          mapInstance = mapController.selectionMap;
        } else {
          mapInstance = mapController.instance;
        }

        if (!mapInstance) {
          return;
        }

        for (var l = 0; l < result.svcResL[0].res.locL.length; l++) {
          var tmpMarker = Hafas.Util.maps.showHCILocation(result.svcResL[0].res.locL[l], mapInstance, null, false, {selectable: true});
          _me.Controller.Map.toolbox.stationsNearList.push(tmpMarker);
        }
      }
    }
  },
  clearSearchMarker: function() {
    if (this.markerSEARCH != null) {
      this.instance.hideContent(this.markerSEARCH);
      this.instance.removeContent(this.markerSEARCH);
    }
  },
  showSearchResults: function(data) {
    //Hafas.Util.maps.showHCILocation(data, this.Controller.Map.instance);
    var locationCrd = Hafas.Util.geo.hciCrdToHafasCoord(data.crd);
    var map = this.Controller.Map.instance;
    var html;
    map.setOffset({x: 0, y: 0});
    this.Controller.Map.clearSearchMarker();

    // Render infobox
    Hafas.Modules.Render.render(
        {
          file: 'common.map.html',
          template: 'Common_Map_Toolbox',
          model: {
            location: data
          }
        },
        Hafas.bind(function(htmlRendered) {
          html = htmlRendered;
        }, this)
    );

    this.Controller.Map.markerSEARCH = map.createContent({
      type: 'location',
      coord: Hafas.Util.geo.hciCrdToHafasCoord(data.crd),
      imageurl: Hafas.Util.getMarkerPath('DEFAULT_MARKER_URL_SELECTION'),
      imagewidth: Hafas.Config.Maps.DEFAULT_MARKER_URL_SELECTION_WIDTH,
      imageheight: Hafas.Config.Maps.DEFAULT_MARKER_URL_SELECTION_HEIGHT,
      hotspot: {x: Hafas.Config.Maps.DEFAULT_MARKER_URL_SELECTION_WIDTH / 2, y: Hafas.Config.Maps.DEFAULT_MARKER_URL_SELECTION_HEIGHT},
      text: data.name,
      infotitle: data.name,
      infocontent: html,
      selectable: true
    });
    map.showContent(this.Controller.Map.markerSEARCH);
    map.triggerEvent(map.getContent(this.Controller.Map.markerSEARCH).content,'click');
    map.centerToGeo(locationCrd, Hafas.Config.Maps.searchPredefinedZoom);
  },
  updateSize: function() {
    var mapInstance;
    if (this.main) {
      mapInstance = this.main.Controller.Map.instance;
    }
    if (!this.main && typeof this.Controller != 'undefined') {
      mapInstance = this.Controller.Map.instance;
    }
    if(mapInstance != null) {
    mapInstance.updateSize();
    }
  },
  openMapViewer: function(opts) {
    // switch this-context
    var _me = this;

    // get MapContainer as HTML-Element
    var $mapView = Hafas('#' + _me.mapContainer, false);
    var $mapViewHeader = Hafas('#' + _me.mapContainer + ' .lyr_pageMapHeader', false);

    $mapView.style.top = 0;
    $mapView.style.left = 0;
    $mapView.style.zIndex = 1000000;
    $mapView.style.height = window.innerHeight - 1 + 'px';
    $mapView.addClassName('js_singleViewMode');

    $mapViewHeader.removeAttribute('hidden');
    $mapViewHeader.setAttribute('aria-hidden', false);

    // render map Header
    Hafas.Modules.Render.render({
      file: 'common.map.html',
      target: 'HFS_PageMapHeader',
      template: 'Common_Map_SingleViewModeHeader',
      model: {}
    }, function() {
      _me.Controller.Map.updateSize();
      _me.Controller.Map.updateOffset();
    });
  },
  closeMapViewer: function(opts) {
    // switch this-context
    var _me = this;

    // get MapContainer as HTML-Element
    var $mapView = Hafas('#' + _me.mapContainer, false);
    var $mapViewHeader = Hafas('#' + _me.mapContainer + ' .lyr_pageMapHeader', false);

    // reset Styles
    $mapView.removeAttribute('style');
    $mapView.removeClassName('js_singleViewMode');

    $mapViewHeader.setAttribute('hidden', 'hidden');
    $mapViewHeader.setAttribute('aria-hidden', true);

    Hafas.ps.pub('/app/events/resize');
  },
  showGraph: function(data) {
    if(typeof data.type == 'undefined') {
    var reqObj = Hafas.Core.newType('hafasHCIRequestObject', 'JourneyGraph', {});
      var requestName = 'JourneyGraph';
    }else{
      var reqObj = Hafas.Core.newType('hafasHCIRequestObject', data.type, {});
      var requestName = data.type;
    }

    for (var g = 0; g < this.Controller.Map.locGraphMapContent.length; g++) {
      Hafas.Util.maps.hideLocGraph(this.Controller.Map.locGraphMapContent[g],this.Controller.Map.instance,true);
    }

    if (data.pid) {
      reqObj.add('req.jnyFltrL');
      reqObj.add('req.jnyFltrL.type', 'PID');
      reqObj.add('req.jnyFltrL.mode', 'INC');
      reqObj.add('req.jnyFltrL.value', data.pid);
    }
    if(data.jid) {
      reqObj.add('req.jnyFltrL');
      reqObj.add('req.jnyFltrL.type', 'JID');
      reqObj.add('req.jnyFltrL.mode', 'INC');
      reqObj.add('req.jnyFltrL.value', data.jid);
    }

    if(typeof data.locL != 'undefined'){
      for(var d=0; d < data.locL.length;d++) {
        reqObj.add('req.locL');
        reqObj.add('req.locL.lid', data.locL[d]);
        reqObj.add('req.type', 'RT_GRAPH');
      }
    }


    if(typeof data.toggleMode == 'undefined'){
      var centerToResult = true;
    }else{
      var centerToResult = false;
    }

    var hciRequest = Hafas.Core.newType('hafasHCIRequest',{requests:[reqObj]});

    // close all open tabs
    Hafas.ps.pub('/GUI/tabs/closeAll');

    Hafas.Core.newType("hafasRequest", {
      request : requestName,
      requestType : "hci",
      hciRequestObj: hciRequest,
      callback : Hafas.bind(function (data) {
        if(data.status.error == false) {
          var mapContent = Hafas.Util.maps.showGraph(this.Controller.Map.instance,data);
          this.Controller.Map.locGraphMapContent.push(mapContent);
          if(typeof mapContent.polylines != 'undefined' && centerToResult) {
            this.Controller.Map.instance.centerToContent(mapContent.polylines)
          }
        }
      },this)
    });
  },
  openMapViewerForDetails: function(opts) {
    // switch this-context
    var _me = this;

    if (this.layoutClass == "small")
    {
      // get MapContainer as HTML-Element
      var $mapView = Hafas('#' + _me.mapContainer, false);
      var $mapViewHeader = Hafas('#' + _me.mapContainer + ' .lyr_pageMapHeader', false);
      $mapViewHeader.innerHTML = "";

      this.Controller.Map.updateSize();
    }

    this.Controller.Map.connection.centerRoute();
  },
  selectLocation: function(map, loc, common, markerParams) {
    map.removeAllToolboxItems();

    if(typeof this.Controller.SQ.additionalInstances != 'undefined'){
      this.Controller.SQ.additionalInstances = {};
    }

    if(typeof markerParams != 'undefined'){
      var markerReference = markerParams.cc;
    }else{
      var markerReference = null;
    }

    if (common == undefined)
      common = null;

    Hafas.Modules.Maps.getToolbox({location:loc, common:common,markerRef: markerReference }).show(map);

    if(typeof Hafas.Config.Maps.useNetspider != 'undefined' && Hafas.Config.Maps.useNetspider){
      Hafas.bind(this.Controller.Map.toggleNetSpider,this)('Location',true,{lid: loc.lid});
    }
  },
  getLocDetails: function(locData){
    Hafas.Util.location.getLocDetails(locData, this.Controller.Map.renderLocDetails);
  },
  renderLocDetails: function(locDetailsResult,requestData){
    var linesTargetContainer = Hafas('[data-toolbox-lines="lines_' + requestData.extId + '"]',false);
    if(linesTargetContainer){

      if(typeof locDetailsResult.status.error == 'undefined' || locDetailsResult.status.error == false){
        var model = {};
        if(locDetailsResult.svcResL.length > 0 && locDetailsResult.svcResL[0].res.locL.length > 0) {
          var tmpLoc = locDetailsResult.svcResL[0].res.locL[0];
          model.prodRefLResolved = tmpLoc.pRefLResolved;
          Hafas.Modules.Render.render({
            file: 'common.map.html',
            target: linesTargetContainer,
            template: 'Common_Map_Lines',
            model: model
          }, Hafas.bind(function (htmlRendered) {

          }));
        }
      }
    }
  },
  closeToolbox: function() {
    if (this.Controller.Map.instance) {
      this.Controller.Map.instance.removeToolboxItem('mapSelection','id');
    }
    if (this.Controller.Map.selectionMap) {
      this.Controller.Map.selectionMap.removeToolboxItem('mapSelection', 'id');
    }
    if(typeof this.Controller.Map.locGraphMapContent != 'undefined') {
      for (var g = 0; g < this.Controller.Map.locGraphMapContent.length; g++) {
        Hafas.Util.maps.hideLocGraph(this.Controller.Map.locGraphMapContent[g], this.Controller.Map.instance, true);
      }
    }
  },
  closeToolboxItem: function(map,toolboxData){

    var toolboxId = null;
    if(toolboxData != undefined)
      toolboxId = toolboxData.id;

    if (this.Controller.Map.instance) {
      this.Controller.Map.instance.removeToolboxItem(toolboxId, 'id');
    }
    if (this.Controller.Map.selectionMap) {
      this.Controller.Map.selectionMap.removeToolboxItem(toolboxId, 'id');
    }
  },
  closeAllToolboxItems: function(){
    this.Controller.Map.instance.removeAllToolboxItems();
  },
  setLocation: function(locObj){
    var coord = Hafas.Util.geo.hciCrdToHafasCoord(locObj.crd);
    this.Controller.Map.instance.centerToGeo(coord);
    this.Controller.Map.instance.setZoom(Hafas.Config.Maps.searchPredefinedZoom,"api");
    Hafas('#MapLocation',false).value = locObj.name;
  },

  // karte auf koordinate zentrieren und ggf. auch zoomstufe setzen
  centerToGeo: function(data){
    this.Controller.Map.instance.centerToGeo(data.coord,data.zoom);
  },

  // zoomstufe setzen
  setZoom: function(zoom){
    this.Controller.Map.instance.setZoom(zoom,'api');
  },

  centerCurrentRoute: function(){
    if(typeof this.Controller.Map.connection != 'undefined'){
      this.Controller.Map.connection.centerRoute();
    }
  },
  setLocationMarker: function(type, location) {
    if (!location) {
      console.warn('No location set!!!');
      return;
    }

    var mapController = this.Controller.Map;
    if (Hafas.Config.layoutMode == '_classic') {
      var mapInstance = mapController.selectionMap;
    } else {
      var mapInstance = mapController.instance;
    }

    if (!mapInstance) {
      return;
    }

    var lon = Hafas.Util.location.getValueOfLid(location.lid, "x");
    var lat = Hafas.Util.location.getValueOfLid(location.lid, "y");
    var crd = Hafas.Core.newType("hafasCCoord", {lon: lon, lat: lat});
    switch (type) {
      case 'dep':
        var markerTmpl = 'START';
        break;
      case 'arr':
        var markerTmpl = 'DEST';
        break;
    }

    if (mapController['marker' + markerTmpl] != null) {
      mapInstance.hideContent(mapController['marker' + markerTmpl]);
      mapInstance.removeContent(mapController['marker' + markerTmpl]);
    }

    if(lon.length == 0 && lat.length == 0){
      return;
    }

    var params = {
      type: 'location',
      data: {
        type: type
      },
      coord: crd,
      imageurl: Hafas.Util.getMarkerPath('DEFAULT_MARKER_URL_' + markerTmpl),
      imagewidth: Hafas.Config.Maps['DEFAULT_MARKER_URL_' + markerTmpl + '_WIDTH'],
      imageheight: Hafas.Config.Maps['DEFAULT_MARKER_URL_' + markerTmpl + '_HEIGHT'],
      hotspot: {
        x: Hafas.Config.Maps['DEFAULT_MARKER_' + markerTmpl + '_HOTSPOT_X'],
        y: Hafas.Config.Maps['DEFAULT_MARKER_' + markerTmpl + '_HOTSPOT_Y']
      },
      priority: 10000,
      draggable: true,
      onDrag: function(coord, marker, map) {

      }
    };

    if (Hafas.Config.layoutMode != '_classic') {
      params.draggable = true;
    } else {
      params.draggable = false;
    }


    mapController['marker' + markerTmpl] = mapInstance.createContent(params);
    mapInstance.showContent(mapController['marker' + markerTmpl]);
    mapController.updateSelectionView(crd);
  },
  clearLocationMarker: function(type) {
    var markerTmpl = type;
    switch (type) {
      case 'dep':
        markerTmpl = 'START';
        break;
      case 'arr':
        markerTmpl = 'DEST';
    }

    var mapController = this.Controller.Map;
    if (typeof mapController['marker' + markerTmpl] != 'undefined' && mapController['marker' + markerTmpl] != null) {
      mapController.instance.hideContent(mapController['marker' + markerTmpl]);
      mapController.instance.removeContent(mapController['marker' + markerTmpl]);
      mapController['marker' + markerTmpl] = null;
    }
  },
  resetMobilityRadarSelection: function(){
     if(this.Controller.Map.mobilityRadar){
        this.Controller.Map.mobilityRadar.resetLocationSelection();
     }
  },
  reverseLookUp: function(crd, par) {
    var mapController = this.Controller.Map;
    
    // typ muss gesetzt sein
    if( (typeof par.data != 'undefined') && (typeof par.data.type != 'undefined') ){
    
      // connection vorhanden, also neue route berechnen
      // Instant Drag & Drop
      if (typeof mapController.connection != 'undefined') {
        // Suche mit aktueller Koordinate
        if(typeof mapController.dragDropTimeout != 'undefined' && mapController.dragDropTimeout != null){
          window.clearTimeout(mapController.dragDropTimeout);
        }
        mapController.dragDropTimeout = window.setTimeout(Hafas.bind(function(){
          this.Controller.Map.currentDragRequestCounter++;
          this.Controller.Map.dragConnection(crd,par.data.type,this.Controller.Map.currentDragRequestCounter);
        },this),300);
      }
      
    }
  },
  updateSelectionView: function(crd) {
    var availableMarkers = ['START', 'DEST'];
    var allMarkers = [];
    if (Hafas.Config.layoutMode == '_classic') {
      var mapInstance = this.selectionMap;
    } else {
      var mapInstance = this.instance;
    }
    for (var i = 0; i < availableMarkers.length; i++) {
      if (this['marker' + availableMarkers[i]] != null) {
        allMarkers.push(this['marker' + availableMarkers[i]]);
      }
    }
    var selectionVisible = mapInstance.isPointInBoundingBox(crd);
    if (allMarkers.length > 1) {
      // mgab: Darf nicht bei Drag&Drop ausgeführt werden, vorerst auskommentiert
      if(!selectionVisible) {
        this.instance.centerToContent(allMarkers, {maxZoom: 14});
      }
    } else if (allMarkers.length == 1) {
      if(!selectionVisible) {
      mapInstance.centerToGeo(mapInstance.content[allMarkers[0]].coord);
      }
      //mapInstance.centerToContent(allMarkers[0],{maxZoom: mapInstance.getZoom("api")});
    }
  },
  sideDrawer: {
    bodyClick: function() {
      Hafas.ps.pub('/map/sidedrawer/close');
    },
    toggle: function(opts) {
      var pageHeaderHeight = 0;
      var _me = this;
      if (Hafas.Config.showPageHeader) {
        pageHeaderHeight = Hafas("#HFS_PageHeader").clientHeight;
      }

      // ++/map/sidedrawer/toggle++
      if (opts.ev) {
        opts.ev.preventDefault();
        opts.ev.stopPropagation();
      }

      var $sideDrawer = Hafas('#' + this.mapSideDrawer);

      var $sideDrawerTrigger = Hafas('#' + this.mapSideDrawerTrigger, false);

      $sideDrawer.style.top = pageHeaderHeight + 'px';

      if ($sideDrawerTrigger.className.match(/js_sideDrawerOpened/g)) {
        Hafas.bind(this.Controller.Map.sideDrawer.close, this)();
      }
      else {
        Hafas.bind(this.Controller.Map.sideDrawer.show, this)();
        Hafas.ps.pub('/tracking/event/mobilitymap-options-main', [ { typ: 'event', key: 'mobilitymap-options-main' } ]);
        Hafas.ps.pub('/tracking/event/mobilitymap-options-pressed', [ { typ: 'event', key: 'mobilitymap-options-pressed' } ]);
      }
      $sideDrawer.scrollTop = 0;
    },
    show: function() {

      var $sideDrawer = Hafas('#' + this.mapSideDrawer);
      var $sideDrawerTrigger = Hafas('#' + this.mapSideDrawerTrigger, false);
        document.body.style.overflowY = 'hidden';

        $sideDrawer.setAttribute('aria-hidden', false);
        $sideDrawer.removeAttribute('hidden');
        $sideDrawer.addClassName('js_sideDrawerOpened');
        $sideDrawerTrigger.addClassName('js_sideDrawerOpened');

        $sideDrawer.addEventListener('click', function(ev) {
          ev.stopPropagation();
        });
        document.body.addEventListener('click', this.Controller.Map.sideDrawer.bodyClick);

      if(Hafas.Modules.History)
        Hafas.Modules.History.addSubView("/map/sidedrawer/close", "MapMenu", {});
    },
    close: function() {
      var $sideDrawer = Hafas('#' + this.mapSideDrawer);
      var $sideDrawerTrigger = Hafas('#' + this.mapSideDrawerTrigger, false);

      if ($sideDrawer.className.match(/js_sideDrawerOpened/g)) {
        document.body.style.overflowY = 'auto';
        //Hafas('#HFS_SideDrawerMask', false).parentNode.removeChild(Hafas('#HFS_SideDrawerMask', false));
        $sideDrawer.setAttribute('aria-hidden', true);
        $sideDrawer.setAttribute('hidden', 'hidden');
        $sideDrawer.removeClassName('js_sideDrawerOpened');
        $sideDrawerTrigger.removeClassName('js_sideDrawerOpened');
        document.body.removeEventListener('click', this.Controller.Map.sideDrawer.bodyClick);

        if(Hafas.Modules.History)
          Hafas.Modules.History.removeCurrentStep("MapMenu");
      }
    },
    resize: function(opts) {
      // ++/map/sidedrawer/resize++
      if (Hafas.Config.showPageHeader)
        var pageHeaderHeight = Hafas("#HFS_PageHeader").clientHeight;
      else
        var pageHeaderHeight = 0;

      var $sideDrawer = Hafas('#' + this.mapSideDrawer, false);
      $sideDrawer.style.height = (window.innerHeight - pageHeaderHeight) + 'px';
    },
    toggleList: function(opts)
    {
      Hafas.ps.pub('/GUI/common/atomToggleContainer', [opts]);

      if(Hafas.Config.Maps.useSingleOpenCatMode)
        this.Controller.Map.sideDrawer.closeAllLists(opts.trigger);
    },
    closeAllLists: function(except)
    {
      var options = {
        open: false
      };
      var tabList = Hafas(".lyr_sideDrawItemTab", true);
      for(var i = 0; i < tabList.length; i++)
      {
        var tab = tabList[i];

        if(tab === except)
          continue;

        options.trigger = tab;
        Hafas.ps.pub('/GUI/common/atomToggleContainer', [options]);
      }
    }

  },
  toggleZoomHint: function(id, show){
    var item = Hafas('[data-zoom-hint="' + id + '"]', false);
    if(item)
      Hafas.Util.gui.setVisibility(item, show);
  },
  disableContent: function(content, disableBool, type) {
    this.Controller.Map.toggleZoomHint(content.id, disableBool);
  },
  updateMapContentDisableStatus: function(boolval, group){
    this.Controller.Map.toggleZoomHint(group, boolval);
  },
  hideConnection: function(opts) {
    if (this.connection) {
      this.connection.hide(opts);
    }
  },
  hideDragRoute: function() {
    if (this.dragRoute) {
      Hafas.Util.maps.hideHCITrips([this.dragRoute], this.main.Controller.Map.instance);
      this.dragRoute = null;
    }
  },
  hideTripMarker: function() {
    if (this.markerSTART != null) {
      this.instance.hideContent(this.markerSTART);
    }
    if (this.markerDEST != null) {
      this.instance.hideContent(this.markerDEST);
    }
  },
  restoreTripMarker: function(){
    if (this.markerSTART != null) {
      this.instance.showContent(this.markerSTART);
    }
    if (this.markerDEST != null) {
      this.instance.showContent(this.markerDEST);
    }
  },
  centerLocation: function(data) {
    if (data.type == 'dep') {
      this.Controller.Map.connection.centerLocation(data.secIdx, 'dep');
    } else if (data.type == 'arr') {
      this.Controller.Map.connection.centerLocation(data.secIdx, 'arr');
    } else if (data.type == 'intermediate') {
      this.Controller.Map.connection.centerLocation(data.secIdx, data.locIdx);
    }
  },
  centerSection: function(data) {
    this.Controller.Map.connection.centerToSection(data.secIdx);
  },
  centerSegment: function(data){
    this.Controller.Map.connection.centerToSegment(data);
  },
  removeHighlightSegment: function(){
    this.Controller.Map.connection.removeSegmentHighlightPolyline();
  },
  showConnection: function(connection, options) {
    this.connection = Hafas.Core.newType("hafasConnection", connection, this.instance);
    try {
    this.connection.show(options);
    this.connection.centerRoute();
    this.hideTripMarker();
      Hafas.ps.pub('/map/showConnectionOnMap',[connection]);

      // Tracking
      Hafas.ps.pub('/tracking/screen/map', [ { typ: 'screen', key: 'map', data: { type: 'routedetails' } } ]);
    }
    catch(e) {}
  },
  showCurrentConnection: function() {
    if (this.connection) {
      this.connection.show();
      this.connection.centerRoute();
      this.hideTripMarker();
    }
  },
  locationDrag: function(coord,mapContent,evt){
    if(this.dragDropDelay) {
      window.clearTimeout(this.dragDropDelay);
      this.dragDropDelay = null;
    }
    this.dragDropDelay = window.setTimeout(Hafas.bind(function(){
      if(mapContent.data == undefined)
        return;
      var type = mapContent.data.type;
      this.Controller.Map.currentDragRequestCounter++;
      this.Controller.Map.dragConnection(coord,type,this.Controller.Map.currentDragRequestCounter);
    },this),300);
  },
  locationDragEnd: function(crd,mapContent,map) {
    
    var mapController = this.Controller.Map;
    var zoom = map.getZoom("api");
    var type = null;  // ggf. steht kein Typ fest
    if((typeof mapContent.data != 'undefined') && (typeof mapContent.data.type != 'undefined')){
      type = mapContent.data.type;
    }
    
    // ggf. timeout fuer "suchvorschau" entfernen
    if (typeof mapController.dragDropTimeout != 'undefined' && mapController.dragDropTimeout != null) {
      window.clearTimeout(mapController.dragDropTimeout);
    }
    
    // vermeiden, dass ggf. noch responses von der drag-bewegung verarbeitet werden
    mapController.currentDragRequestCounter++;
    
    // kein typ gesetzt, dann wie klick auf karte handhaben (reverselookup)
    if(!type){
      map.showReverseLookupToolbox(crd);
    }
    else{
      Hafas.Util.geo.reverseLookup(crd, Hafas.bind(function(locL) {
        // ort als start/ziel setzen
        this.Controller.TP.instance.setLocation(type, locL[0]);
        
        var initSearch = false;
        
        // ort ist start und es ist bereits ein ziel gesetzt, dann suche starten
        if( (type == 'dep') && (this.Controller.TP.instance.getLocation('arr')) ) {
          Hafas.bind(mapController.setLocationMarker,this)('arr', this.Controller.TP.instance.getLocation('arr'));
          initSearch = true;
        }
        else if( (type == 'arr') && (this.Controller.TP.instance.getLocation('dep')) ){
          Hafas.bind(mapController.setLocationMarker,this)('dep', this.Controller.TP.instance.getLocation('dep'));
          initSearch = true;
        }
        
        // Suche Starten, wenn bereits vorher einmal gesucht wurde
        if( (initSearch) && (typeof mapController.connection != 'undefined') ){
          
          // bisherige verbindung ausblenden (inkl. der marker)
          mapController.hideConnection({startDestMarker: true});
          this.Controller.TP.selectedConnection = null;
          // ggf. auch eine drag-vorschau-route
          mapController.hideDragRoute();
          mapController.hideDragHint();

          // dieses cluster soll nach der suche angezeigt werden (ist ggf nicht das default cluster)
          if(Hafas.Config.TP.useGrouping) {
            var tpController = this.Controller.TP;
            for(var cIdx=0; cIdx < Hafas.Config.TP.cluster.length; cIdx++){
              if(Hafas.Config.TP.cluster[cIdx].type == tpController.visibleClusterGroup){
                tpController.showClusterGroup = {id: tpController.visibleClusterGroup, clusterIndex: cIdx};
                break;
              }
            }
          }
          
          this.Controller.TP.instance.search({
            ptCallback: Hafas.bind(this.Controller.TP.showResultOverview,this),
            ivCallback: Hafas.bind(this.Controller.TP.showIVResultOverview,this)
          });
        }
      }, this),function(){},{zoomDependent:true,zoom: zoom});
    }
    Hafas.ps.pub('/tracking/event/tripplanner-dragdrop-gesture-completed', [ { typ: 'event', key: 'tripplanner-dragdrop-gesture-completed' } ]);
  },
  dragConnection: function(coord,type,reqIndex){
    if(!Hafas.Config.TP.useDragPreview)
      return;
    if(this.connection == undefined)
      return;

    var mapController = this;
    
    // lid aus koordinate erzeugen
    var name = (coord.getLon() / 1000000) + " / " + (coord.getLat() / 1000000);
    var lid = "A=16@O="+name+"@X=" + coord.getLon() + "@Y=" + coord.getLat();
    var meterPerPixel = mapController.instance.getZoom("meter_x") / mapController.instance.mapDiv.clientWidth;
    var distValue = meterPerPixel * 15;
    var draggedHciLocation = {
      name: name,
      lid: lid,
      crd: coord.getHciCrd(),
      dist : distValue,
      pCls : 63,
      eteId: type
    };
    var destLoc = this.main.Controller.TP.instance.getLocation('arr');
    var startLoc = draggedHciLocation;
    if(type == 'arr'){
      startLoc = this.main.Controller.TP.instance.getLocation('dep');
      destLoc = draggedHciLocation;
    }
    var dragConnection = Hafas.Core.newType('hafasTP',{
      depLocL: [startLoc],
      arrLocL: [destLoc],
      routePreview: true
    });
    
    // bisherige verbindung ausblenden
    mapController.hideConnection({startDestMarker:false});
    // ggf. auch eine drag-vorschau-route ausblenden
    mapController.hideDragRoute();
    mapController.hideDragHint();
    
    // neue verbindung suchen
    dragConnection.search({
      ptCallback: Hafas.bind(function(data){
        // falls der request zu alt ist, dann ignorieren
        if(reqIndex < mapController.currentDragRequestCounter) {
          return;
        }
        
        // ggf. bisherige verbindung ausblenden
        mapController.hideConnection({startDestMarker:false});
        // ggf. auch eine drag-vorschau-route ausblenden
        mapController.hideDragRoute();
        mapController.hideDragHint();
        
        // verbindung gefunden?
        if(data.connectionResult.length > 0) {  
          this.dragRoute = Hafas.Util.maps.createHCITrip(data.connectionResult[0].conn,this.main.Controller.Map.instance,data.connectionResult[0].common,{
            polyline : {
              show : true,
              params : {
                opacity : 0.7
              }
            },
            locations : {
              show : false
            }
          });
          Hafas.ps.pub('/map/dragDrop/connectionFound',[coord,data.renderConnections[0]]);
        }
        else{
          Hafas.ps.pub('/map/dragDrop/noConnection',[coord]);
        }
      },this)
    
    });
  },
  showDragHint: function(data){
      this.Controller.Map.hideDragHint();
      var containerParams = {
           type:'container',
           html: data.html,
           coord: data.coord
      };
      if(typeof data.className != 'undefined') {
         containerParams.className = data.className;
      }
      this.Controller.Map.dragHint = this.Controller.Map.instance.createContent(containerParams);
      this.Controller.Map.instance.showContent(this.Controller.Map.dragHint);
      if(typeof data.callback == 'function') {
         data.callback();
      }
  },
  hideDragHint: function(){
     if(typeof this.dragHint != 'undefined' && this.dragHint != null) {
        this.instance.hideContent(this.dragHint);
        this.instance.removeContent(this.dragHint);
     }
  },
  showDragConnectionPreview: function(coord,connection){
     Hafas.Modules.Render.render(
         {
           file: 'common.map.html',
           template: 'Common_DragHintConnection',
           model: connection
         },
         Hafas.bind(function(htmlRendered) {
           Hafas.bind(this.Controller.Map.showDragHint,this)({
              className: 'hfs_dragHintOnMap',
              html: htmlRendered,
              coord: coord,
              callback: function(){
                Hafas.ps.pub('/GUI/durationBar/create', [{connection: connection, container: Hafas('#HFS_ConnectionId_DragPreview .hfs_durationBar')}]);
                Hafas.ps.pub('/GUI/durationBar/recalculate');
              }
           });
         }, this)
     );
  },
  showDragNoConnection: function(coord){
     Hafas.Modules.Render.render(
         {
           file: 'common.map.html',
           template: 'Common_DragHint',
           model: {
             text: Hafas.Modules.i18n.get('TP.error.t_N_noResultsExtended')
           }
         },
         Hafas.bind(function(htmlRendered) {
           Hafas.bind(this.Controller.Map.showDragHint,this)({
              html: htmlRendered,
              coord: coord
           });
         }, this)
     );
  },
  showConnectionMap: function(conn, opts) {
    this.main.Controller.Map.connectionMaps[opts.arrayIdx] = Hafas.Core.newType('hafasMapLeaflet', 'HFS_ConnectionMap_' + opts.arrayIdx, {
      coord: Hafas.Core.newType("hafasCCoord", Hafas.Config.Maps.predefinedArea),
      zoom: Hafas.Config.Maps.predefinedZoom,
      reverseLookup: false,
      layer: [{
        "name": "HAFAS BaseLayer",
        "id": "HafasBaseMap",
        "type": "static",
        "url": Hafas.Config.staticTileURL,
        "attribution": "&copy; OpenStreetMap contributors",
        "isBaseLayer": true
      }]
    });

    //console.log('+++++', opts.arrayIdx);
    if(Hafas.Config.layoutMode == '_classic'){
      var connectionConfig = {
        draggableRoute: false
      };
    }else{
      var connectionConfig = {};
    }

    this.main.Controller.Map.connectionMaps[opts.arrayIdx].connection = Hafas.Core.newType("hafasConnection", conn, this.main.Controller.Map.connectionMaps[opts.arrayIdx], connectionConfig);
    this.main.Controller.Map.connectionMaps[opts.arrayIdx].connection.show(opts);
    this.main.Controller.Map.connectionMaps[opts.arrayIdx].connection.centerRoute();
  },
  showGeoPosition: function(){
    if (typeof Hafas.Config.Maps.usePositionWatcher !== "undefined" && Hafas.Config.Maps.usePositionWatcher) {
      // Callback wird jedes mal, wenn die Position geändert wird getriggert.
      // Es soll jedoch nicht jedesmal die aktuelle Position zentriert werden.
      this.instance.activePositionWatcher = false;
      var _watcherCallback                = function (position) {
        if (position && !this.instance.activePositionWatcher && typeof position.browserPosition !== 'undefined') {
          var crd = Hafas.Util.geo.browserLatLngToHafasCoord(position.browserPosition.coords);
          this.instance.centerToGeo(crd,Hafas.Config.Maps.searchPredefinedZoom);
          this.instance.activePositionWatcher = true;
        }
      };
      Hafas.Util.geo.activateActualPositionWatcher(Hafas.bind(_watcherCallback, this), true);
    }
    else {
      // Alte Funktion:
      Hafas.Util.getGeoLocation(Hafas.bind(function (geoLoc) {
        if (typeof geoLoc.coords != 'undefined') {
          var crd = Hafas.Util.geo.browserLatLngToHafasCoord(geoLoc.coords);
          this.instance.centerToGeo(crd,Hafas.Config.Maps.searchPredefinedZoom);
        }
    },this), false, true);
    }
    // Tracking
    Hafas.ps.pub('/tracking/event/map-current-position-button-clicked', [ { typ: 'event', key: 'map-current-position-button-clicked' } ]);
    Hafas.ps.pub('/tracking/event/map-currentposition-pressed', [ { typ: 'event', key: 'map-currentposition-pressed' } ]);
  },
  hoverDetails: function(data){
    try {
      var me = this,
          selectedGroup,
          results,
          currConnection;


      // hoverRoutes werden nur mit angeschlossener Maus angezeigt.
      if (Hafas.Util.hasMouseSupport()) {
        // Ergebnisse Gruppe
        if (this.Controller.TP.instance.isGroupingUsed()) {

          if (data.connectionType == 'heart') {
            selectedGroup = this.Controller.TP.groupFavMode + '_score';
          } else {
            selectedGroup = data.connectionType;
          }

          results = this.Controller.TP.instance.data.results.groups[selectedGroup];
          currConnection = results.connections[data.arrayIdx].resolvedConnection;
        } else {

          if (Hafas.Config.layoutMode === '_fullmap') {
            results = this.Controller.TP.instance.data.results.connectionResult;
            currConnection = this.Controller.TP.instance.data.results.renderConnections[data.arrayIdx];
          } else {
            results = this.Controller.TP.instance.getResults(data.connectionType);
            currConnection = results.renderConnections[data.arrayIdx];
          }
        }

        if (typeof me.hoverRoutes == 'undefined') {
          me.hoverRoutes = {};
        }

        // noch keine Verbindung geladen oder gehoverte verbindung ist die momentan sichtbare verbindung, dann ignorieren
        console.log(me.Controller.Map.connection.connectionData.cksum + " " + currConnection.cksum);
        if ((typeof me.Controller.Map.connection == 'undefined') || (me.Controller.Map.connection.connectionData.cksum == currConnection.cksum)) {
          return
        }

        if (typeof me.hoverRoutes[currConnection.cksum] == 'undefined') {
          me.hoverRoutes[currConnection.cksum] = Hafas.Core.newType("hafasConnection", currConnection, this.Controller.Map.instance);
        }
        me.hoverRoutes[currConnection.cksum].show({
          centerRoute: false,
          stops: false,
          changes: false,
          opacity: 0.4
        });
      }
    }catch(e){
      console.log(e);
    }
  },
  unhoverDetails: function(data){
    var me = this;
    // hoverRoutes werden nur mit angeschlossener Maus angezeigt.
    if(typeof me.hoverRoutes != 'undefined' && Hafas.Util.hasMouseSupport()){
      for(var r in me.hoverRoutes){
        me.hoverRoutes[r].hide();
      }
    }
  },
  /**
   * Zeichnet die aktuelle Position auf der Karte.
   *
   * @method Controller.Map.showCurrentPositionMarker
   * @param location
   * @param targetId
   * @param accuracyRadius
   */
  showCurrentPositionMarkerPoint: function (location, accuracyRadius) {
    // Diese Funktion zeigt die aktuelle Position mit einem Kreis auf der Karte an.
    var _map = this.Controller.Map;
    // FKR & MROE: Ohne ungefähre Position durch Radius. (14.09.2017)
    // var radius = accuracyRadius || 1000;
    if (location && location.crd) {
      if (typeof _map.currentPositionMarker === 'undefined') {
        _map.currentPositionMarker = {};
      }
      var map    = this.Controller.Map.instance;
      var newCrd = Hafas.Util.geo.hciCrdToHafasCoord(location.crd);
      // Standard-Position
      if (typeof _map.currentPositionMarker.crd === 'undefined') {
        _map.currentPositionMarker.crd = {
          param: {
            lat: 0,
            lon: 0
          }
        };
      }
      // Positionsänderung oder erste Position
      if ((_map.currentPositionMarker.crd.param.lat !== newCrd.param.lat &&
        _map.currentPositionMarker.crd.param.lon !== newCrd.param.lon)) {
        // Alte Marker abräumen
        if (_map.currentPositionMarker.whiteOutline) {
          map.hideContent(_map.currentPositionMarker.whiteOutline);
          map.removeContent(_map.currentPositionMarker.whiteOutline);
          _map.currentPositionMarker.whiteOutline = null;
        }
        if (_map.currentPositionMarker.innerCircle) {
          map.hideContent(_map.currentPositionMarker.innerCircle);
          map.removeContent(_map.currentPositionMarker.innerCircle);
          _map.currentPositionMarker.innerCircle = null;
        }
        // FKR & MROE: Ohne ungefähre Position durch Radius. (14.09.2017)
        // if(_map.currentPositionMarker.accuracyRadius) {
        //   map.hideContent(_map.currentPositionMarker.accuracyRadius);
        //   map.removeContent(_map.currentPositionMarker.accuracyRadius);
        //   _map.currentPositionMarker.accuracyRadius = null;
        // }
        if (_map.instance.isPointInGlobalBoundingBox(newCrd)) {
          _map.currentPositionMarker = {
            crd         : newCrd,
            whiteOutline: map.createContent({
              type   : 'circle',
              coord  : newCrd,
              radius : 6,
              color  : '#FFFFFF',
              opacity: 1,
              unit   : 'pixel'
            }),
            innerCircle : map.createContent({
              type   : 'circle',
              coord  : newCrd,
              radius : 4,
              color  : Hafas.Config.Styling.PrimaryClr,
              opacity: 1,
              unit   : 'pixel'
            })

            // FKR & MROE: Ohne ungefähre Position durch Radius. (14.09.2017)
            // accuracyRadius: map.createContent({
            //   type: 'circle',
            //   coord: newCrd,
            //   radius: radius,
            //   color: Hafas.Config.Styling.PrimaryClr,
            //   opacity: 0.1,
            //   fillOpacity: 0.2,
            //   unit: 'meter'
            // })
          };
          // map.showContent(_map.currentPositionMarker.accuracyRadius);
          map.showContent(_map.currentPositionMarker.whiteOutline);
          map.showContent(_map.currentPositionMarker.innerCircle);
        }
        else {
          if (!_map.locationAlertShowed) {
            alert(Hafas.Modules.i18n.get('common.locationErrors.t_N_outsideBoundingBox'));
            _map.locationAlertShowed = true;
          }
        }
      }
    }
  },
  /**
   * Löscht die aktuelle Position auf der Karte.
   *
   * @method Controller.Map.hideCurrentPositionMarker
   */
  hideCurrentPositionMarkerPoint: function () {
    var _map = this.Controller.Map;
    if (typeof _map.currentPositionMarker === 'undefined') {
      return false;
    }
    var map = this.Controller.Map.instance;
    // Alte Marker abräumen
    if (_map.currentPositionMarker.whiteOutline) {
      map.hideContent(_map.currentPositionMarker.whiteOutline);
      map.removeContent(_map.currentPositionMarker.whiteOutline);
      _map.currentPositionMarker.whiteOutline = null;
    }
    if (_map.currentPositionMarker.innerCircle) {
      map.hideContent(_map.currentPositionMarker.innerCircle);
      map.removeContent(_map.currentPositionMarker.innerCircle);
      _map.currentPositionMarker.innerCircle = null;
    }
    // if (_map.currentPositionMarker.accuracyRadius) {
    //   map.hideContent(_map.currentPositionMarker.accuracyRadius);
    //   map.removeContent(_map.currentPositionMarker.accuracyRadius);
    //   _map.currentPositionMarker.accuracyRadius = null;
    // }
    _map.currentPositionMarker = undefined;
    return true;
  },
  handleDroppedMarker: function(screenCoords,markerType){
    
    var map = this.Controller.Map.instance;
    var crd = map.scr2geo(screenCoords);
    var zoom = map.getZoom("api");
    
    Hafas.Util.geo.reverseLookup(crd, Hafas.bind(function(locL) {
      // ort als start/ziel setzen
      this.Controller.TP.instance.setLocation(markerType, locL[0]);
        
    }, this),function(){},{zoomDependent:true,zoom: zoom});
    
    
  },
  toggleNetSpider: function(type, boolval, data){
      if(boolval) {
        var polyData = Hafas.bind(this.Controller.Map.showGraph, this)({
          type: 'LocGraph',
          locL: [data.lid]
        });
      }else{
        for (var g = 0; g < this.Controller.Map.locGraphMapContent.length; g++) {
          Hafas.Util.maps.hideLocGraph(this.Controller.Map.locGraphMapContent[g],this.Controller.Map.instance,true);
        }
      }
  },
  handleReverseLookupResult: function(map,crd,loc){
    if(Hafas.Config.Maps.useNetspider && loc.type == 'S'){
      Hafas.bind(this.Controller.Map.toggleNetSpider,this)('location', true, { lid: loc.lid });
    }
    if(Hafas.Config.Maps.toolbox.showLines == true && loc.type == 'S' && typeof loc.pRefLResolved == 'undefined'){
      Hafas.Util.location.getLocDetails(loc, this.Controller.Map.renderLocDetails);
    }
  },
  toggleNearStations: function(boolval,loc){
    if(boolval) {
      if (Hafas.Config.Maps.toolbox.showAdrNearStops == true && loc.type != 'S') {
        this.Controller.Map.getNearbyStops(loc);
      }
    }
  },
  getNearbyStops: function(location){
    var requestObj = {
      ring: {
        cCrd: {
          y: parseInt(location.crd.y),
          x: parseInt(location.crd.x)
        },
        maxDist: Hafas.Config.Maps.toolbox.stationsNearRadius
      },
      getPOIs: false,
      getStops: true,
      maxLoc: 3
    };

    var targetContainer = Hafas('[data-toolbox-stationboard-stationsnear="' + location.extId + '"]',false);

    Hafas.Core.newType('hafasRequest', {
      request: "LocGeoPos",
      requestType: "hci",
      requestobj: requestObj,
      loadingModule: "LocGeoPos",
      callback: function(res) {
        if(typeof res.svcResL != 'undefined' && res.svcResL.length > 0){
          var result = res.svcResL[0].res;
          var distances = [];
          for(var l=0; l < result.locL.length;l++){
            Hafas.Util.getRef("ico", result.common, result.locL[l]);
            distances.push(result.locL[l].dist);
          }
          var minDistance = Math.min.apply(null, distances);
          Hafas.Util.location.resolveProductList(result.locL,result.common);

          Hafas.Modules.Render.render(
              {
                target: targetContainer,
                file: 'map.flyout.html',
                template: 'Common_Flyout_StationNear',
                model: {
                  locL: result.locL,
                  minDistance: Hafas.Util.getDistanceInUnit(minDistance),
                  showAdrNearStopsBoards: Hafas.Config.Maps.toolbox.showAdrNearStopsBoards
                }
              },
              Hafas.bind(function(htmlRendered) {
                html = htmlRendered;
              }, this)
          );
        }
      }
    });
  },
  foldMapControls: function(){
    var controls = this.Controller.Map.instance.getControls();
    for(var c = 0; c < controls.length;c++){
      var tmpControl = controls[c];
      if(typeof tmpControl.ctrlInstance != 'undefined' && typeof tmpControl.ctrlInstance.fold == 'function') {
        tmpControl.ctrlInstance.fold();
      }
    }
  },
  resizeFlyouts: function(){
    var map = this.Controller.Map.instance;
    var toolboxItems = map.getAllToolboxItems();
    if(toolboxItems.length > 0){
       map.refreshFlyoutPosition(toolboxItems[0]);
    }
  },
  showControl: function(button, show) {
    Hafas.Util.gui.setVisibility(button, show);
  },
  fullscreen: {
    buttonClicked: function (options, map, data) {
      Hafas.ps.pub('/GUI/fullscreen/toggle', [this.Controller.Map.instance.getControlById('fullscreen').ctrlInstance.getCurrentState().name, document.documentElement]);
    },
    buttonCreated: function (button) {
      // two requisites
      //  1. only show the button if webapp is placed in an iframe -> otherwise it doesn't make much sense to have a fullscreen button
      //  2. only show the button if fullscreen functionality is available in this browser
      Hafas.ps.pub('/map/showControl', [button, (Hafas.Util.appIsInIFrame() && Hafas.Util.fullscreen.isSupported())]);
    },
    changed: function (fullscreenActive, event) {
      this.Controller.Map.instance.getControlById('fullscreen').ctrlInstance.changeState(fullscreenActive ? 'exit' : 'fullscreen');
    },
  },
  cleanup: function() {
    /*console.log("---------------------------------");
     console.log("CLEAN UP MAP CONTROLLER CALLED...");
     console.log("---------------------------------");*/
  }
};
